<template>
  <v-form v-model="form_validate_status" ref="form" :loading="loading">
    <v-card max-width="750" class="mx-auto" color="grey-lighten-3">
      <v-layout>
        <CustomAppBar :page="5" :title="$t('info_card.title_page5')" />
        <v-main
          ><v-card-text>
            <v-row
              ><v-col cols="12" sm="6"
                ><h6>{{ $t("info_card.prename") }}</h6>
                <v-autocomplete
                  variant="outlined"
                  density="compact"
                  v-model="prename_id"
                  :items="prenames"
                  :item-title="(item) => objectTranslator(item, 'FULLNAME')"
                  :item-value="(item) => item.PREFIX_NAME_ID"
                  :rules="requiredRules"
                >
                </v-autocomplete>
              </v-col>
              <v-col cols="12" sm="12">
                <NameTH v-model="nameSurnameTH" />
              </v-col>
              <v-col cols="12" sm="6">
                <h6>{{ $t("info_card.vital_status") }}</h6>
                <VitalStatusCard v-model="vital_status_id" />
              </v-col>
            </v-row>
          </v-card-text>
          <div v-if="vital_status_id === '1'">
            <v-divider /><v-card-text>
              <v-radio-group
                v-model="thaiOrForeign"
                :rules="requiredRules"
                :mandatory="false"
                row
              >
                <v-row>
                  <v-col cols="12" sm="4">
                    <v-radio
                      v-bind:label="$t('info_card.thai_parent')"
                      value="thai"
                    ></v-radio>
                  </v-col>
                  <v-col cols="12" sm="4">
                    <v-radio
                      v-bind:label="$t('info_card.foreigner_parent')"
                      value="other"
                    ></v-radio>
                  </v-col>
                </v-row>
              </v-radio-group>
              <v-row
                ><v-col cols="12" sm="6">
                  <span v-if="thaiOrForeign === 'thai'"
                    ><h6>{{ $t("info_card.fill_thai_citizenID") }}</h6>
                    <CitizenID v-model="citizen_id"
                  /></span>
                  <span v-if="thaiOrForeign === 'other'"
                    ><h6>{{ $t("info_card.fill_passport_number") }}</h6>
                    <PassportNumber v-model="passport_number"
                  /></span>
                </v-col>
              </v-row>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-text
              ><v-row
                ><v-col cols="12" sm="6"
                  ><h6>{{ $t("info_card.mobile") }}</h6>
                  <MobileForm v-model="mobile" /></v-col
                ><v-col cols="12" sm="6"
                  ><h6>{{ $t("info_card.occupation") }}</h6>
                  <OccupationCard v-model="occupation_id" /></v-col
                ><v-col cols="12" sm="6">
                  <h6>{{ $t("info_card.revenue") }}</h6>
                  <RevenueCard
                    v-model="revenue_id" /></v-col></v-row></v-card-text
            ><v-divider></v-divider>
            <v-card-text>
              <h5>{{ $t("info_card.address") }}</h5>
              <v-radio-group v-model="address_type" :mandatory="false" row>
                <v-row>
                  <v-col cols="12" sm="4">
                    <v-radio
                      v-bind:label="$t('info_card.parent_address')"
                      value="home"
                    ></v-radio>
                  </v-col>
                  <v-col cols="12" sm="4">
                    <v-radio
                      v-bind:label="$t('info_card.parent_contact')"
                      value="contact"
                    ></v-radio>
                  </v-col>
                  <v-col cols="12" sm="4">
                    <v-radio
                      v-bind:label="$t('info_card.parent_new_address')"
                      value="other"
                    ></v-radio>
                  </v-col>
                </v-row>
              </v-radio-group>
              <div v-if="address_type === 'other'">
                <h5>{{ $t("info_card.address_registration") }}</h5>
                <v-radio-group
                  v-model="thaiOrForeignCountry"
                  :mandatory="false"
                  row
                >
                  <v-row>
                    <v-col cols="12" sm="4">
                      <v-radio
                        v-bind:label="$t('info_card.in_thai')"
                        value="inThai"
                      ></v-radio>
                    </v-col>
                    <v-col cols="12" sm="4">
                      <v-radio
                        v-bind:label="$t('info_card.foreign_country')"
                        value="foreignCountry"
                      ></v-radio>
                    </v-col>
                  </v-row>
                </v-radio-group>
                <v-row v-if="thaiOrForeignCountry === 'foreignCountry'"
                  ><v-col cols="12" sm="6"
                    ><h6>{{ $t("info_card.country") }}</h6>
                    <NationForm v-model="country_id" /></v-col
                ></v-row>
                <div v-if="thaiOrForeignCountry === 'inThai'">
                  <v-row>
                    <v-col cols="12" sm="6">
                      <h6>{{ $t("info_card.house_number") }}</h6>
                      <v-text-field
                        v-model="house_number"
                        :rules="requiredRules"
                        variant="outlined"
                        density="compact"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6">
                      <h6>{{ $t("info_card.moo") }}</h6>
                      <v-text-field
                        v-model="moo"
                        :rules="requiredRules"
                        variant="outlined"
                        density="compact"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6">
                      <h6>{{ $t("info_card.village_name") }}</h6>
                      <v-text-field
                        v-model="village_name"
                        :rules="requiredRules"
                        variant="outlined"
                        density="compact"
                      ></v-text-field>
                    </v-col>

                    <v-col cols="12" sm="6">
                      <h6>{{ $t("info_card.soi") }}</h6>
                      <v-text-field
                        v-model="soi"
                        :rules="requiredRules"
                        variant="outlined"
                        density="compact"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6">
                      <h6>{{ $t("info_card.street") }}</h6>
                      <v-text-field
                        v-model="street"
                        :rules="requiredRules"
                        variant="outlined"
                        density="compact"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6">
                      <h6>{{ $t("info_card.province") }}</h6>
                      <v-autocomplete
                        v-model="province_id"
                        :items="provinces"
                        :item-title="
                          (item) => objectTranslator(item, 'PROVINCE_NAME')
                        "
                        :item-value="(item) => item.PROVINCE_ID"
                        :rules="requiredRules"
                        @update:modelValue="update_province"
                        variant="outlined"
                        density="compact"
                      ></v-autocomplete>
                    </v-col>
                    <v-col cols="12" sm="6">
                      <h6>{{ $t("info_card.district") }}</h6>
                      <v-autocomplete
                        v-model="district_id"
                        :items="filtered_districts"
                        :item-title="
                          (item) => objectTranslator(item, 'DISTRICT_NAME')
                        "
                        :item-value="(item) => item.DISTRICT_ID"
                        :rules="requiredRules"
                        :disabled="province_id === null"
                        @update:modelValue="update_district"
                        variant="outlined"
                        density="compact"
                      ></v-autocomplete>
                    </v-col>
                    <v-col cols="12" sm="6">
                      <h6>{{ $t("info_card.sub_district") }}</h6>
                      <v-autocomplete
                        v-model="sub_district_id"
                        :items="filtered_subDistricts"
                        :item-title="
                          (item) => objectTranslator(item, 'SUB_DISTRICT_NAME')
                        "
                        :item-value="(item) => item.SUB_DISTRICT_ID"
                        :rules="requiredRules"
                        :disabled="district_id === null"
                        variant="outlined"
                        density="compact"
                      ></v-autocomplete>
                    </v-col>
                  </v-row>
                </div>
              </div>
            </v-card-text>
          </div>
          <v-divider></v-divider>
          <v-card-text
            ><div
              class="text-end mb-2 text-red"
              v-if="is_saved_before_page === false"
            >
              {{ $t("info.have_not_fill_page_before") }}
            </div>
            <div class="text-end">
              <v-btn color="primary" size="large" class="mr-2" to="/page4"
                >Back</v-btn
              >
              <v-btn
                color="primary"
                size="large"
                :disabled="is_saved_before_page === false"
                @click="saveData"
                >{{ is_lock_kmitl1 === true ? "Next" : "Save & Next" }}</v-btn
              >
            </div></v-card-text
          >
        </v-main>
      </v-layout>
    </v-card>
  </v-form>
</template>

<script>
import { inlineTranslator, objectTranslator } from "@/helper/translator";
import validator from "@/helper/validator";
import CustomAppBar from "@/components/info_cards/CustomAppBar.vue";
import NameTH from "@/components/info_cards/NameTH.vue";
import CitizenID from "@/components/info_cards/CitizenID.vue";
import PassportNumber from "@/components/info_cards/PassportNumber.vue";
import MobileForm from "@/components/info_cards/MobileForm.vue";
import NationForm from "@/components/info_cards/NationForm.vue";
import OccupationCard from "@/components/info_cards/OccupationCard.vue";
import RevenueCard from "@/components/info_cards/RevenueCard.vue";
import VitalStatusCard from "@/components/info_cards/VitalStatus.vue";
import PageProvider from "@/services/page.provider";
const pageService = new PageProvider();

export default {
  name: "PageFour",
  components: {
    CustomAppBar,
    NameTH,
    CitizenID,
    PassportNumber,
    MobileForm,
    OccupationCard,
    RevenueCard,
    NationForm,
    VitalStatusCard,
  },
  data: () => ({
    form_validate_status: false,
    loading: false,
    is_lock_kmitl1: true,
    is_saved_before_page: false,

    prename_id: null,
    nameSurnameTH: {
      nameTH: null,
      surnameTH: null,
    },
    vital_status_id: null,
    thaiOrForeign: "thai", // other
    citizen_id: null,
    passport_number: null,
    mobile: null,
    occupation_id: null,
    revenue_id: null,

    thaiOrForeignCountry: "inThai", // foreignCountry
    address_type: null,

    house_number: null,
    moo: null,
    village_name: null,
    soi: null,
    street: null,
    province_id: null,
    district_id: null,
    sub_district_id: null,
    country_id: null,

    requiredRules: [validator.required],
  }),
  methods: {
    inlineTranslator,
    objectTranslator,

    update_province() {
      this.sub_district_id = null;
      this.district_id = null;
    },
    update_district() {
      this.sub_district_id = null;
    },
    async getData() {
      this.loading = true;
      this.is_lock_kmitl1 =
        this.surrogated_student_info.LOCK_KMITL1 == "0" ? false : true;

      const data = await pageService.getPageMother(this.uid).catch((error) => {
        this.$toast.error(JSON.stringify(error.response.data.message));
      });
      this.prename_id = data.PREFIX_NAME_ID;
      this.nameSurnameTH.nameTH = data.PARENT_FNAME_TH;
      this.nameSurnameTH.surnameTH = data.PARENT_LNAME_TH;
      this.vital_status_id = data.VITAL_STATUS_ID;
      this.citizen_id = data.CITIZEN_ID;
      this.passport_number = data.PASSPORT_NUMBER;
      this.mobile = data.MOBILE;
      this.occupation_id = data.OCCUPATION_ID;
      this.revenue_id = data.REVENUE_ID;
      if (
        (this.citizen_id == "" && this.passport_number == "") ||
        (this.citizen_id &&
          this.citizen_id.length == 13 &&
          this.passport_number == "") ||
        data.length === 0
      ) {
        this.thaiOrForeign = "thai";
      } else {
        this.thaiOrForeign = "other";
      }

      if (data.other) {
        this.address_type = "other";
        this.country_id = data.other.NATION_ID;

        if (this.country_id == "TH") {
          this.thaiOrForeignCountry = "inThai";
          this.house_number = data.other.HOUSE_NUMBER;
          this.moo = data.other.MOO;
          this.village_name = data.other.VILLAGE_NAME;
          this.soi = data.other.SOI;
          this.street = data.other.STREET;
          this.sub_district_id = data.other.SUB_DISTRICT_ID;
          this.district_id = data.other.DISTRICT_ID;
          this.province_id = data.other.PROVINCE_ID;
        } else {
          this.thaiOrForeignCountry = "foreignCountry";
        }
      } else if (data.home) {
        this.address_type = "home";
      } else if (data.contact) {
        this.address_type = "contact";
      }
      this.loading = false;
    },
    async saveData() {
      if (this.form_validate_status === true) {
        if (this.is_lock_kmitl1 === false) {
          this.loading = true;

          let other_address = {};
          if (this.vital_status_id === "1") {
            if (this.thaiOrForeign == "thai") {
              this.passport_number = null;
            } else {
              this.citizen_id = null;
            }

            //กรณีที่อยู่ต่างประเทศ
            if (this.thaiOrForeignCountry === "foreignCountry") {
              other_address = {
                HOUSE_NUMBER: null,
                MOO: null,
                VILLAGE_NAME: null,
                SOI: null,
                STREET: null,
                SUB_DISTRICT_ID: null,
                NATION_ID: this.country_id,
              };
            } else {
              //กรณีที่อยู่ในไทย
              other_address = {
                HOUSE_NUMBER: this.house_number,
                MOO: this.moo,
                VILLAGE_NAME: this.village_name,
                SOI: this.soi,
                STREET: this.street,
                SUB_DISTRICT_ID: this.sub_district_id,
                NATION_ID: "TH",
              };
            }
          } else {
            this.citizen_id = null;
            this.passport_number = null;
            this.mobile = null;
            this.occupation_id = null;
            this.revenue_id = null;
            this.address_type = null;
          }
          const response = await pageService
            .setPageMother({
              uid: this.uid,
              PREFIX_NAME_ID: this.prename_id ?? null,
              PARENT_FNAME_TH: this.nameSurnameTH.nameTH ?? null,
              PARENT_LNAME_TH: this.nameSurnameTH.surnameTH ?? null,
              VITAL_STATUS_ID: this.vital_status_id ?? null,
              CITIZEN_ID: this.citizen_id ?? null,
              PASSPORT_NUMBER: this.passport_number ?? null,
              MOBILE: this.mobile ?? null,
              OCCUPATION_ID: this.occupation_id ?? null,
              REVENUE_ID: this.revenue_id ?? null,
              address_type: this.address_type,
              other_address: other_address,
            })
            .catch((error) => {
              this.$toast.error(JSON.stringify(error.response.data.message));
              this.loading = false;
            });
          if (response && response.status) {
            this.$toast.success(this.$t("toast.save_successfully"));
            this.$router.push("/page6");
          } else this.$toast.error(this.$t("toast.cannot_save"));
          this.loading = false;
        } else {
          this.$router.push("/page6");
        }
      } else {
        this.$toast.error(this.$t("toast.cannot_save"));
      }
    },
  },
  computed: {
    uid() {
      return this.$store.state.user.surrogated_student_uid;
    },
    surrogated_student_info() {
      return this.$store.state.user.surrogated_student_info;
    },
    subDistricts: function () {
      return this.$store.state.ref.subDistricts;
    },
    districts: function () {
      return this.$store.state.ref.districts;
    },
    provinces: function () {
      return this.$store.state.ref.provinces;
    },
    filtered_districts() {
      let data = [];
      if (this.province_id !== null) {
        data = this.districts.filter((item) =>
          this.province_id.includes(item.PROVINCE_ID)
        );
      }
      return data;
    },
    filtered_subDistricts() {
      let data = [];
      if (this.district_id !== null) {
        data = this.subDistricts.filter((item) =>
          this.district_id.includes(item.DISTRICT_ID)
        );
      }
      return data;
    },
    prenames() {
      let data = this.$store.state.ref.prenames;
      data = data.filter((item) => item.GENDER === "female" && item.PREFIX_NAME_ID != "960");
      return data;
    },
  },
  async created() {
    await this.$store.dispatch("user/getUserInfo");
    this.is_saved_before_page =
      this.surrogated_student_info.ENTERED.includes("4");
    if (this.is_saved_before_page === false) {
      this.$router.push("/main");
    }

    this.$store.dispatch("ref/getSubDistricts");
    this.$store.dispatch("ref/getDistricts");
    this.$store.dispatch("ref/getProvinces");
    this.$store.dispatch("ref/getPrenames");

    this.getData();
  },
};
</script>
<style scoped></style>
